import dayjs from "dayjs";
import {PA_ID_NUMBER_DEFAULT_VALUE} from "../config";
import {PUBLIC_AUTHORITY} from "../ra-filling/config";

const mapRaOwnerToPersonBillingOwner = (raOwner: any): any => {
    return({
        customerId: raOwner.cbId,
        firstName: raOwner.firstName,
        lastName: raOwner.lastName,
        fiscalCode: raOwner.fiscalCode,
        gender: raOwner.gender,
        birthDate: dayjs(raOwner.birthDate),
        birthNation: raOwner.birthNation,
        birthPlace: raOwner.birthPlace?.description,
        countryResidence: raOwner.countryResidence,
        mobile: raOwner.mobile,
        prefix: raOwner.prefix,
        firstEmail: raOwner.email,
        certifiedEmail: raOwner.certifiedEmail,
        drivingLicenseNumber: raOwner.drivingLicenseNumber,
        billingCountry: raOwner.countryResidence,
        billingProvince: raOwner.provinceResidence,
        billingCity: raOwner.cityResidence?.description,
        billingAddress: raOwner.address,
        billingStreetNumber: raOwner.streetNumber,
        billingPostalCode: raOwner.postCode,
        billingAddressGoogleSearch: '',
        cfValidated: raOwner.cfValidated
    })
}

const currentBillingOwner = (curBoInfo: any, type: number) => {
    if(!!curBoInfo) {
        switch (type) {
            case 0:
                return {
                    'customerId': curBoInfo.cbId || curBoInfo.customerId,
                    'firstName': curBoInfo.firstName,
                    'lastName': curBoInfo.lastName,
                    'fiscalCode': curBoInfo.fiscalCode,
                    'gender': curBoInfo.gender,
                    'birthDate': dayjs(curBoInfo.birthDate),
                    'birthNation': curBoInfo.birthNation,
                    'birthPlace': curBoInfo.birthPlace?.description,
                    'countryResidence': curBoInfo.countryResidence,
                    'mobile': curBoInfo.mobile,
                    'prefix': curBoInfo.prefix,
                    'firstEmail': curBoInfo.email,
                    'certifiedEmail': curBoInfo.certifiedEmail ?? '',
                    'drivingLicenseNumber': curBoInfo.drivingLicenseNumber,
                    'billingCountry': curBoInfo.billingCountry,
                    'billingCity': curBoInfo.billingCity?.description ?? '',
                    'billingProvince': curBoInfo.billingProvince,
                    'billingAddress': curBoInfo.billingAddress ?? '',
                    'billingStreetNumber': curBoInfo.billingStreetNumber ?? '',
                    'billingPostalCode': curBoInfo.billingPostalCode ?? '',
                    'cfValidated': curBoInfo.cfValidated ?? null,
                    'billingAddressGoogleSearch': ''
                }
            case 1:
                return {
                    'customerId': curBoInfo.cbId || curBoInfo.customerId,
                    'vatNumberCountry': {
                        code: curBoInfo.vatNumberCountry,
                        description: curBoInfo.vatNumberCountry
                    },
                    'legalEntity': curBoInfo.legalEntity,
                    'fiscalCode': curBoInfo.fiscalCode,
                    'companyName': curBoInfo.companyName,
                    'billingCountry': curBoInfo.billingCountry,
                    'billingProvince': curBoInfo.billingProvince,
                    'billingCity': curBoInfo.billingCity?.description,
                    'billingAddress': curBoInfo.billingAddress,
                    'billingStreetNumber': curBoInfo.billingStreetNumber,
                    'billingPostalCode': curBoInfo.billingPostalCode,
                    'firstEmail': curBoInfo.email,
                    'certifiedEmail': curBoInfo.certifiedEmail,
                    'invoiceCode': curBoInfo.sdicode,
                    'VATNumber': curBoInfo.vatNumber,
                    'siren': curBoInfo.siren,
                    'siret': curBoInfo.siret,
                    'linkedToBa': curBoInfo.linkedToBa,
                    billingAddressGoogleSearch: '',
                    paIdNumber: curBoInfo.publicAuthority === '1' ? (!!curBoInfo.paIdNumber ? curBoInfo.paIdNumber : PA_ID_NUMBER_DEFAULT_VALUE) : ''
                }
            case 2:
                return {
                    'customerId': curBoInfo.cbId || curBoInfo.customerId,
                    'vatNumberCountry': {
                        code: curBoInfo.vatNumberCountry,
                        description: curBoInfo.vatNumberCountry
                    },
                    'legalEntity': curBoInfo.legalEntity,
                        'fiscalCode': curBoInfo.fiscalCode,
                    'companyName': curBoInfo.companyName,
                    'billingCountry': curBoInfo.billingCountry,
                    'billingProvince': curBoInfo.billingProvince,
                    'billingCity': curBoInfo.billingCity?.description,
                    'billingAddress': curBoInfo.billingAddress,
                    'billingStreetNumber': curBoInfo.billingStreetNumber,
                    'billingPostalCode': curBoInfo.billingPostalCode,
                    'firstEmail': curBoInfo.email,
                    'certifiedEmail': curBoInfo.certifiedEmail,
                    'invoiceCode': curBoInfo.sdicode,
                    'VATNumber': curBoInfo.vatNumber,
                    'siren': curBoInfo.siren,
                    'siret': curBoInfo.siret,
                    'linkedToBa': curBoInfo.linkedToBa,
                    billingAddressGoogleSearch: '',
                    publicAuthority: PUBLIC_AUTHORITY[Number(!!curBoInfo.publicAuthority ? curBoInfo.publicAuthority : '0')],
                    paIdNumber: curBoInfo.publicAuthority === '1' ? (!!curBoInfo.paIdNumber ? curBoInfo.paIdNumber : PA_ID_NUMBER_DEFAULT_VALUE) : ''
                }
        }
    }
    return null;
}

const getChengesData = (changesData: string[], field: string, form: any) => {
    const discardFields = ['verifiedDocuments', 'billingAddressGoogleSearch'];
    if (!!form) {
        for (const [key, value] of Object.entries(form)) {
            if (value === true && !discardFields.includes(key)) {
                changesData.push(field + '.' + key);
            }
        }
    }
}

// const boFromSearchCustomer = (customer: ICustomer, type: number, boType: 'first' | 'second', bodv: any) => {
//     if (!!customer) {
//         switch (type) {
//             case 0:
//                 bodv[boType].person = {
//                     'customerId': customer.cbId || customer.customerId,
//                     'firstName': customer.firstName,
//                     'lastName': customer.lastName,
//                     'gender': customer.gender,
//                     'birthDate': dayjs(customer.birthDate),
//                     'birthNation': customer.birthNation,
//                     'birthPlace': customer.birthPlace?.description ?? '',
//                     'countryResidence': customer.countryResidence,
//                     'fiscalCode': customer.fiscalCode,
//                     'drivingLicenseNumber': customer.drivingLicenseNumber ?? '',
//                     'firstEmail': customer.email,
//                     'prefix': customer.mobilePrefix,
//                     'mobile': customer.mobile,
//                     'billingCountry': customer.billingCountry,
//                     'billingProvince': customer.billingProvince,
//                     'billingCity': customer.billingCity?.description ?? '',
//                     'billingAddress': customer.billingAddress,
//                     'billingStreetNumber': customer.billingStreetNumber,
//                     'billingPostalCode': customer.billingPostalCode,
//                     'certifiedEmail': customer.certifiedEmail,
//                     'billingAddressGoogleSearch': '',
//                     'cfValidated': customer.cfValidated
//                 }
//                 break;
//             case 1:
//                 bodv[boType].vatNumber = {
//                     'customerId': customer.cbId || customer.customerId,
//                     'vatNumberCountry': {code: customer.vatNumberCountry, description: customer.vatNumberCountry},
//                     'legalEntity': customer.legalEntity,
//                     'fiscalCode': customer.fiscalCode,
//                     'companyName': (customer.companyName as string),
//                     'billingCountry': customer.billingCountry,
//                     'billingProvince': customer.billingProvince,
//                     'billingCity': customer.billingCity?.description ?? '',
//                     'billingAddress': customer.billingAddress,
//                     'billingStreetNumber': customer.billingStreetNumber,
//                     'billingPostalCode': customer.billingPostalCode,
//                     'firstEmail': customer.email,
//                     'certifiedEmail': customer.certifiedEmail,
//                     'invoiceCode': customer.invoiceCode,
//                     'VATNumber': customer.vatNumber,
//                     'linkedToBa': customer.linkedToBa,
//                     'paIdNumber': customer.publicAuthority === '1' ? (!!customer.paIdNumber ? customer.paIdNumber : PA_ID_NUMBER_DEFAULT_VALUE) : ''
//                 }
//                 break;
//             case 2:
//                 bodv[boType].company = {
//                     'customerId': Number(customer.cbId || customer.customerId),
//                     'vatNumberCountry': {code: customer.vatNumberCountry, description: customer.vatNumberCountry},
//                     'legalEntity': customer.legalEntity,
//                     'fiscalCode': customer.fiscalCode,
//                     'companyName': (customer.companyName as string),
//                     'billingCountry': customer.billingCountry,
//                     'billingProvince': customer.billingProvince,
//                     'billingCity': customer.billingCity?.description ?? '',
//                     'billingAddress': customer.billingAddress,
//                     'billingStreetNumber': customer.billingStreetNumber,
//                     'billingPostalCode': customer.billingPostalCode,
//                     'firstEmail': customer.email,
//                     'certifiedEmail': customer.certifiedEmail,
//                     'invoiceCode': customer.invoiceCode,
//                     'VATNumber': customer.vatNumber,
//                     'linkedToBa': customer.linkedToBa,
//                     'publicAuthority': PUBLIC_AUTHORITY[Number(!!customer.publicAuthority ? customer.publicAuthority : '0')],
//                     'paIdNumber': customer.publicAuthority === '1' ? (!!customer.paIdNumber ? customer.paIdNumber : PA_ID_NUMBER_DEFAULT_VALUE) : ''
//                 }
//                 break;
//         }
//     }
//     return bodv;
// }

const resetFieldBO = (customer: any, type: number, boType: 'first' | 'second', form: any, isFirst = true) => {
    if (!!customer) {
        switch (type) {
            case 0:
                form.resetField(`billingOwnerInfo.${boType}.person.customerId`, {defaultValue:  customer.cbId || customer.customerId});
                form.resetField(`billingOwnerInfo.${boType}.person.firstName`, {defaultValue:  customer.firstName});
                form.resetField(`billingOwnerInfo.${boType}.person.lastName`, {defaultValue:  customer.lastName});
                form.resetField(`billingOwnerInfo.${boType}.person.gender`, {defaultValue:  customer.gender});
                form.resetField(`billingOwnerInfo.${boType}.person.birthDate`, {defaultValue:  !!customer.birthDate ? dayjs(customer.birthDate) : null});
                form.resetField(`billingOwnerInfo.${boType}.person.birthNation`, {defaultValue:  customer.birthNation});
                form.resetField(`billingOwnerInfo.${boType}.person.birthPlace`, {defaultValue:  customer.birthPlace?.description ?? ''});
                form.resetField(`billingOwnerInfo.${boType}.person.countryResidence`, {defaultValue:  customer.countryResidence});
                form.resetField(`billingOwnerInfo.${boType}.person.fiscalCode`, {defaultValue:  customer.fiscalCode});
                form.resetField(`billingOwnerInfo.${boType}.person.drivingLicenseNumber`, {defaultValue:  customer.drivingLicenseNumber ?? ''});
                form.resetField(`billingOwnerInfo.${boType}.person.firstEmail`, {defaultValue:  customer.email  ?? customer.firstEmail});
                form.resetField(`billingOwnerInfo.${boType}.person.prefix`, {defaultValue:  customer.mobilePrefix});
                form.resetField(`billingOwnerInfo.${boType}.person.mobile`, {defaultValue:  customer.mobile});
                form.resetField(`billingOwnerInfo.${boType}.person.billingCountry`, {defaultValue:  customer.billingCountry});
                form.resetField(`billingOwnerInfo.${boType}.person.billingProvince`, {defaultValue:  customer.billingProvince});
                form.resetField(`billingOwnerInfo.${boType}.person.billingCity`, {defaultValue:  customer.billingCity?.description ?? ''});
                form.resetField(`billingOwnerInfo.${boType}.person.billingAddress`, {defaultValue:  customer.billingAddress});
                form.resetField(`billingOwnerInfo.${boType}.person.billingStreetNumber`, {defaultValue:  customer.billingStreetNumber});
                form.resetField(`billingOwnerInfo.${boType}.person.billingPostalCode`, {defaultValue:  customer.billingPostalCode});
                form.resetField(`billingOwnerInfo.${boType}.person.certifiedEmail`, {defaultValue:  customer.certifiedEmail});
                form.resetField(`billingOwnerInfo.${boType}.person.billingAddressGoogleSearch`, {defaultValue:  ''});
                form.resetField(`billingOwnerInfo.${boType}.person.cfValidated`, {defaultValue:  customer.cfValidated});

                form.setValue(`billingOwnerInfo.${boType}.person.customerId`, customer.cbId || customer.customerId);
                break;
            case 1:
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.customerId`, {defaultValue:  customer.cbId || customer.customerId});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.vatNumberCountry`, {defaultValue:  {code: customer.vatNumberCountry, description: customer.vatNumberCountry}});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.legalEntity`, {defaultValue:  customer.legalEntity});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.fiscalCode`, {defaultValue:  customer.fiscalCode});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.companyName`, {defaultValue:  (customer.companyName as string)});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.billingCountry`, {defaultValue:  customer.billingCountry});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.billingProvince`, {defaultValue:  customer.billingProvince});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.billingCity`, {defaultValue:  customer.billingCity?.description ?? ''});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.billingAddress`, {defaultValue:  customer.billingAddress});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.billingStreetNumber`, {defaultValue:  customer.billingStreetNumber});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.billingPostalCode`, {defaultValue:  customer.billingPostalCode});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.firstEmail`, {defaultValue:  customer.email ?? customer.firstEmail});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.certifiedEmail`, {defaultValue:  customer.certifiedEmail});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.invoiceCode`, {defaultValue:  customer.invoiceCode});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.VATNumber`, {defaultValue:  customer.vatNumber ?? customer.VATNumber});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.linkedToBa`, {defaultValue:  customer.linkedToBa});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.paIdNumber`, {defaultValue:  customer.publicAuthority === '1' ? (!!customer.paIdNumber ? customer.paIdNumber : PA_ID_NUMBER_DEFAULT_VALUE) : ''});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.siren`, {defaultValue: customer.siren});
                form.resetField(`billingOwnerInfo.${boType}.vatNumber.siret`, {defaultValue: customer.siret});

                form.setValue(`billingOwnerInfo.${boType}.vatNumber.customerId`, customer.cbId || customer.customerId);
                break;
            case 2:
                form.resetField(`billingOwnerInfo.${boType}.company.customerId`, {defaultValue: customer.cbId || customer.customerId});
                form.resetField(`billingOwnerInfo.${boType}.company.vatNumberCountry`, {defaultValue: {code: customer.vatNumberCountry, description: customer.vatNumberCountry}});
                form.resetField(`billingOwnerInfo.${boType}.company.legalEntity`, {defaultValue: customer.legalEntity});
                form.resetField(`billingOwnerInfo.${boType}.company.fiscalCode`, {defaultValue: customer.fiscalCode});
                form.resetField(`billingOwnerInfo.${boType}.company.companyName`, {defaultValue: (customer.companyName as string)});
                form.resetField(`billingOwnerInfo.${boType}.company.billingCountry`, {defaultValue: customer.billingCountry});
                form.resetField(`billingOwnerInfo.${boType}.company.billingProvince`, {defaultValue: customer.billingProvince});
                form.resetField(`billingOwnerInfo.${boType}.company.billingCity`, {defaultValue: customer.billingCity?.description ?? ''});
                form.resetField(`billingOwnerInfo.${boType}.company.billingAddress`, {defaultValue: customer.billingAddress});
                form.resetField(`billingOwnerInfo.${boType}.company.billingStreetNumber`, {defaultValue: customer.billingStreetNumber});
                form.resetField(`billingOwnerInfo.${boType}.company.billingPostalCode`, {defaultValue: customer.billingPostalCode});
                form.resetField(`billingOwnerInfo.${boType}.company.firstEmail`, {defaultValue: customer.email ?? customer.firstEmail});
                form.resetField(`billingOwnerInfo.${boType}.company.certifiedEmail`, {defaultValue: customer.certifiedEmail});
                form.resetField(`billingOwnerInfo.${boType}.company.invoiceCode`, {defaultValue: customer.invoiceCode});
                form.resetField(`billingOwnerInfo.${boType}.company.VATNumber`, {defaultValue: customer.vatNumber ?? customer.VATNumber});
                form.resetField(`billingOwnerInfo.${boType}.company.linkedToBa`, {defaultValue: customer.linkedToBa});
                form.resetField(`billingOwnerInfo.${boType}.company.publicAuthority`, {defaultValue: PUBLIC_AUTHORITY[Number(!!customer.publicAuthority ? customer.publicAuthority : '0')]});
                form.resetField(`billingOwnerInfo.${boType}.company.paIdNumber`, {defaultValue: customer.publicAuthority === '1' ? (!!customer.paIdNumber ? customer.paIdNumber : PA_ID_NUMBER_DEFAULT_VALUE) : ''});
                form.resetField(`billingOwnerInfo.${boType}.company.siren`, {defaultValue: customer.siren});
                form.resetField(`billingOwnerInfo.${boType}.company.siret`, {defaultValue: customer.siret});

                form.setValue(`billingOwnerInfo.${boType}.company.customerId`, customer.cbId || customer.customerId);
                break;
        }

        if (isFirst) setTimeout(() => {
            resetFieldBO(customer, type, boType, form, false);
        }, 1)
    }
}

export {
    mapRaOwnerToPersonBillingOwner,
    currentBillingOwner,
    getChengesData,
    resetFieldBO
}